import * as Long from 'long';
import 'tslib';
import '../../proto/index.js';
import '../../core/consts.js';
import '../../core/metrics/logger.js';
import '../../core/metrics/monitor.js';
import { ServiceIdentity } from '../../core/service/RuntimeContext.js';
import '../../core/network/NetworkItem.js';
import { Conversation } from '../../core/model/Conversation.js';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import { ConversationCoreInfo } from '../../core/model/ConversationCoreInfo.js';
import 'json-long';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';

class BroadcastConversation extends Conversation {
    constructor() {
        super(...arguments);
        this.localIndex = Long.ZERO; // 本地最新的 index，用于判断是否存在空洞
    }
    get isMuted() {
        return false;
    }
    get isStickOnTop() {
        return false;
    }
    get isFavorite() {
        return false;
    }
    get toParticipantUserId() {
        return undefined;
    }
    static fromServerConversation(ctx, srv, logid) {
        const conv = new BroadcastConversation(ctx);
        conv.id = srv.conversation_id;
        conv.shortId = srv.conversation_short_id.toString();
        conv.type = srv.conversation_type;
        conv.isOffline = false;
        conv.coreInfo = new ConversationCoreInfo(conv, srv);
        return conv;
    }
    setConversationCursor(cursor) {
        if (cursor > this.localIndex) {
            this.localIndex = cursor;
        }
        this.localIndex = cursor;
    }
    getMessageList(filter = m => m.visible) {
        return this.resolve(ServiceIdentity.BroadcastManager).getList(this.id).filter(filter);
    }
    get unreadCount() {
        return 0;
    }
}

export { BroadcastConversation };
//# sourceMappingURL=BroadcastConversation.js.map
